require('./brokerOrdersAndMovementsActivityHeader.scss');

const React = require('react');
const PropTypes = require('prop-types');
const { FormattedText, formatText } = require('core/i18n').i18n;
const moment = require('moment');

// @commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const { LabelFilterRange } = require('commonsComponents/labelFilterRange');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

// @constants
const { BROKER_JOINT_CONTRACTS_VALUE, BROKER_JOINT_CONTRACTS_CRYPTO } = require('constants/index');
const { DATE_PICKER_CUSTOM_DATE_FORMAT } = require('constants/commonsComponents');

class BrokerOrdersAndMovementsActivityHeader extends React.Component {
    buildFilterDateLabel() {
        const { immFilter } = this.props;
        const immFilterDate = immFilter.get('date');

        if (immFilterDate.get('isActive') && immFilterDate.get('from') && immFilterDate.get('to')) {
            const labelFromDate = moment(immFilterDate.get('from')).format(formatText(DATE_PICKER_CUSTOM_DATE_FORMAT));
            const labelToDate = moment(immFilterDate.get('to')).format(formatText(DATE_PICKER_CUSTOM_DATE_FORMAT));

            return <LabelFilterRange from={labelFromDate} to={labelToDate} />;
        }
    }

    buildFilterStateLabel() {
        const { immFilter } = this.props;

        if (immFilter.getIn(['state', 'translation'])) {
            return (
                <div className="broker-orders-and-movements-activity-header__state-label">
                    {immFilter.getIn(['state', 'translation'])}
                </div>
            );
        }
    }

    render() {
        const { onFilterClick, clearFilter, immFilter, immContract, isSuccess } = this.props;
        const isAnyActiveFilter = !immFilter.get('filtersClear');
        let allOrClearElement, labelFilter, filterBlock;

        if (isAnyActiveFilter) {
            allOrClearElement = (
                <button
                    className="broker-orders-and-movements-activity-header__button-clean"
                    onClick={clearFilter}
                >
                    <FormattedText value="filters-clear" format="uppercase" />
                </button>
            );

            labelFilter = (
                <div className="broker-orders-and-movements-activity-header__labels">
                    {this.buildFilterDateLabel()}
                    {this.buildFilterStateLabel()}
                </div>
            );
        } else {
            allOrClearElement = (
                <FormattedText
                    value="broker-contractNoFilter"
                    format="uppercase"
                    className="broker-orders-and-movements-activity-header__label-all"
                />
            );
        }

        if (
          immContract &&
          (immContract.get('type') === BROKER_JOINT_CONTRACTS_VALUE ||
            immContract.get('type') === BROKER_JOINT_CONTRACTS_CRYPTO) &&
          isSuccess
        ) {
          filterBlock = (
            <section>
              <div className="broker-orders-and-movements-activity-header__filters">
                {allOrClearElement}
                <OKButton
                  id="btn_accountLastMovementsHeader_filterButton"
                  modifier="task"
                  onClick={onFilterClick}
                >
                  <OKTooltip
                    type="descriptive"
                    target={
                      <i className="icon icon-filtrar broker-orders-and-movements-activity-header__filter-settings-icon" />
                    }
                    content={
                      <FormattedText
                        value="filters-filterTooltip"
                        format="uppercase"
                        className="broker-orders-and-movements-activity-header__filter-tooltip-content"
                      />
                    }
                    className="broker-orders-and-movements-activity-header__filter-tooltip"
                    offset={[-5, -25]}
                  />
                </OKButton>
              </div>
              {labelFilter}
            </section>
          );
        }

        return (
            <header className="broker-orders-and-movements-activity-header">
                <div className="broker-orders-and-movements-activity-header__title">
                    <FormattedText value="broker-contractActivityTitle" />
                </div>
                {filterBlock}
            </header>
        );
    }
}

BrokerOrdersAndMovementsActivityHeader.propTypes = {
    immFilter: PropTypes.object.isRequired,
    immContract: PropTypes.object.isRequired,
    onFilterClick: PropTypes.func.isRequired,
    clearFilter: PropTypes.func.isRequired,
    isSuccess: PropTypes.bool.isRequired
};

module.exports = BrokerOrdersAndMovementsActivityHeader;
